<div class="general-container flex flex-col justify-center items-center" *ngIf="!loading">
  <div class="content flex flex-col justify-center items-center gap-x-32 gap-y-80 place-content-center relative">
    <div class="step w-full md:max-w-[80%] flex flex-col gap-40 md:gap-52" *ngIf="step === 0">
      <div class="step-header mt-40 md:mt-0">
        <h2 class="text-center font-sans text-h600 md:text-h800 bg-gradient-2-text pb-[16px]">{{ 'INVEST.INVESTOR_PROFILE.TXT' | translate }}</h2>
        <p class="text-center font-sans text-xl text-gray-40">{{ 'EXPERIENCED_INVESTOR.SUBTITLE' | translate }}</p>
      </div>
      <div class="step-content experience-step flex flex-col gap-32">
        <div class="condition flex flex-col gap-20">
          <p class="condition flex flex-col font-sans text-h400 text-center text-eggplant-100]">{{ 'EXPERIENCED_INVESTOR.Q1.TITLE' | translate }}</p>
          <div class="flex gap-x-32">
            <div class="flex items-center justify-center cursor-pointer w-full" (click)="checkOption('works')"
            [ngClass]="{'option': !worksInSectorSelected, 'option-selected': worksInSectorSelected }">
              <p class="font-sans text-l text-eggplant-100 text-center p-24">{{ 'EXPERIENCED_INVESTOR.YES_WORK' | translate }}</p>
            </div>
            <div class="flex items-center justify-center cursor-pointer w-full" (click)="checkOption('works')"
            [ngClass]="{'option': worksInSectorSelected, 'option-selected': !worksInSectorSelected }">
              <p class="font-sans text-l text-eggplant-100 text-center p-24">{{ 'EXPERIENCED_INVESTOR.NO_WORK' | translate }}</p>
            </div>
          </div>
        </div>
        <div class="condition flex flex-col gap-20">
          <p class="condition flex flex-col font-sans text-h400 text-center text-eggplant-100]">{{ 'EXPERIENCED_INVESTOR.Q2.TITLE' | translate }}</p>
          <div class="flex gap-x-32">
            <div class="flex items-center justify-center cursor-pointer w-full" (click)="checkOption('experience')"
            [ngClass]="{'option': !hasExperienceSelected, 'option-selected': hasExperienceSelected }">
              <p class="font-sans text-l text-eggplant-100 text-center p-24">{{ 'EXPERIENCED_INVESTOR.YES_INVESTED' | translate }}</p>
            </div>
            <div class="flex items-center justify-center cursor-pointer w-full" (click)="checkOption('experience')"
            [ngClass]="{'option': hasExperienceSelected, 'option-selected': !hasExperienceSelected }">
              <p class="font-sans text-l text-eggplant-100 text-center p-24">{{ 'EXPERIENCED_INVESTOR.NO_INVESTED' | translate }}</p>
            </div>
          </div>
        </div>
        <div class="condition flex flex-col gap-20 pb-52" *ngIf="hasExperienceSelected">
          <p class="condition flex flex-col font-sans text-h400 text-center text-eggplant-100]">{{ 'EXPERIENCED_INVESTOR.Q3.TITLE' | translate }}</p>
          <p class="label font-sans text-s text-eggplant-100/[0.4] inline-flex size-fit">{{ 'EXPERIENCED_INVESTOR.Q3.SUBTITLE' | translate }}</p>
          <div class="range-container">
            <ion-range min="0" max="55" [pin]="true" [value]="rangeValueAnnualInvestment" (ionChange)="changeDataRange($event, 'anual-inv')"> <!--[(ngModel)]="value"-->
            </ion-range>
            <div class="range-label">
              <p>5</p>
              <p>20</p>
              <p>30</p>
              <p>+50</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="step w-full md:max-w-[60%] flex flex-col gap-40 md:gap-52" *ngIf="step === 1">
      <div class="step-header mt-40 md:mt-0">
        <h2 class="text-center font-sans text-h600 md:text-h800 bg-gradient-2-text pb-[16px]">{{ 'INVEST.INVESTOR_PROFILE.TXT' | translate }}</h2>
        <p class="text-center font-sans text-xl text-gray-40">{{ 'EXPERIENCED_INVESTOR.Q4.SUBTITLE' | translate }}</p>
      </div>
      <div class="step-content situation-step flex flex-col gap-32">
        <div *ngIf="profile.profileType === 1">
          <div class="condition flex flex-col gap-20">
            <p class="condition flex flex-col font-sans text-h400 text-center text-eggplant-100]">{{ 'EXPERIENCED_INVESTOR.SALARY' | translate }}</p>
            <div class="range-container">
              <ion-range min="0" max="120" pin="true" [value]="rangeAnnualGrossIncome" (ionChange)="changeDataRange($event, 'annual-gross' )"> </ion-range>
              <div class="range-label">
                <p>10k €</p>
                <p>40k €</p>
                <p>75k €</p>
                <p>+100k €</p>
              </div>
            </div>
          </div>
          <div class="condition flex flex-col gap-20">
            <p class="condition flex flex-col font-sans text-h400 text-center text-eggplant-100]">{{ 'EXPERIENCED_INVESTOR.PATRIMONY' | translate }}</p>
            <div class="range-container">
              <ion-range min="0" max="120" pin="true" [value]="rangeFinantialPatrimony" (ionChange)="changeDataRange($event, 'finantial-patrimony')"> </ion-range>
              <div class="range-label">
                <p>10k €</p>
                <p>40k €</p>
                <p>75k €</p>
                <p>+100k €</p>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="profile.profileType === 2">
          <div class="condition flex flex-col gap-20">
            <p class="condition flex flex-col font-sans text-h400 text-center text-eggplant-100]">{{ 'EXPERIENCED_INVESTOR.OWN_RESOURCES' | translate }}</p>
            <div class="range-container">
              <ion-range min="0" max="1000" pin="true" [value]="rangeOwnResources" (ionChange)="changeDataRange($event, 'ownResources')"> </ion-range>
              <div class="range-label">
                <p>100k €</p>
                <p>350k €</p>
                <p>600k €</p>
                <p>+1000k €</p>
              </div>
            </div>
          </div>
          <div class="condition flex flex-col gap-20">
            <p class="condition flex flex-col font-sans text-h400 text-center text-eggplant-100]">{{ 'EXPERIENCED_INVESTOR.TURNOVER' | translate }}</p>
            <div class="range-container">
              <ion-range min="0" max="1000" pin="true" [value]="rangeTurnover" (ionChange)="changeDataRange($event, 'turnover')"> </ion-range>
              <div class="range-label">
                <p>100k €</p>
                <p>350k €</p>
                <p>600k €</p>
                <p>+1000k €</p>
              </div>
            </div>
          </div>
          <div class="condition flex flex-col gap-20">
            <p class="condition flex flex-col font-sans text-h400 text-center text-eggplant-100]">Balance</p>
            <div class="range-container">
              <ion-range min="0" max="1000" pin="true" [value]="rangebalance" (ionChange)="changeDataRange($event, 'balance')"> </ion-range>
              <div class="range-label">
                <p>100k €</p>
                <p>350k €</p>
                <p>600k €</p>
                <p>+1000k €</p>
              </div>
            </div>
          </div>
        </div>

        <div class="condition flex flex-col gap-20">
          <div class="condition flex gap-8">
            <input type="checkbox" (click)="checkOption('dechare')">
            <p class="text-s font-sans text-eggplant-100/[0.4]">{{ 'EXPERIENCED_INVESTOR.CHECK_TXT' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer flex flex-col-reverse py-48 md:pt-24 md:pb-0 md:px-40 md:flex-row justify-between md:border-t md:border-eggplant-10 gap-8" *ngIf="!loading">
  <div class="md:flex justify-center items-center">
    <fun-new-button [buttonType]="'ghost'" [size]="'xl'" title="{{ 'AUTOINVEST.FOOTER.PREV' | translate }}" [classExtra]="' !w-full '" (eventClick)="prev()" icon="arrow-left" [iconPosition]="'left'" [iconVibibleMobile]="false"></fun-new-button>
  </div>
  <div class="w-full md:w-fit md:flex justify-center content-center">
    <fun-new-button [buttonType]="btnType" [size]="'xl'" title="{{ 'AUTOINVEST.FOOTER.NEXT' | translate }}" (eventClick)="next()" icon="arrow-right" [iconPosition]="'right'" [classExtra]="' !w-full '" [iconVibibleMobile]="false" [responsive]="false"></fun-new-button>
  </div>
</div>
<fun-spinner *ngIf="loading"></fun-spinner>